<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 
 
 
 
 
 <link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pz13-2"><a href="#/contents#RR_09" id="CC_09">Regal Order Root Beer Ice Cream Fluff</a></p>
<p class="tx6" id="pz13-3"><i>Here’s to good fellowship. </i></p>
<p class="tx5" id="pz13-4"><b>2 cups root beer </b></p>
<p class="tx5" id="pz13-5"><b>2 cups vanilla ice cream </b></p>
<p class="tx1" id="pz13-6"><span class="dcap">P</span>our ice cold, root beer into a large bowl set in a pan of crushed ice. Add ice cream and beat with a beater until smooth and fluffy. Serve immediately. </p>
<p class="tx" id="pz13-7">Makes 4 servings. </p>
<p class="txrr" id="pz13-8"><i>Alice Schwenke—Houston, Texas</i> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter09.vue?e9e13824